/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BenefitsChartMobile_tradeFirm$ref = any;
type BenefitsChart_tradeFirm$ref = any;
type EnrollCta_tradeFirm$ref = any;
type InviteColleagues_tradeFirm$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LoyaltyModulesWrapper_user$ref: FragmentReference;
export type LoyaltyModulesWrapper_user = {|
  +tradeFirm: ?{|
    +$fragmentRefs: InviteColleagues_tradeFirm$ref & EnrollCta_tradeFirm$ref & BenefitsChart_tradeFirm$ref & BenefitsChartMobile_tradeFirm$ref
  |},
  +$refType: LoyaltyModulesWrapper_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LoyaltyModulesWrapper_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeFirm",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "InviteColleagues_tradeFirm",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "EnrollCta_tradeFirm",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BenefitsChart_tradeFirm",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BenefitsChartMobile_tradeFirm",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '08daa22cbccfcbb8651935ac83a2d63c';
module.exports = node;
